export default "__VITE_ASSET__b18dc326__"